import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-secondary50" }, "Detalhes de aprovação de trocas", -1)
const _hoisted_3 = { class: "flex items-start justify-start gap-8 py-4" }
const _hoisted_4 = { class: "flex flex-col gap-1.5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-[#7f7f8e] text-left" }, "Passou", -1)
const _hoisted_6 = { class: "flex flex-col gap-1.5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-[#7f7f8e] text-left" }, "Recebeu", -1)
const _hoisted_8 = { class: "flex flex-col border border-[#e8e8ed] rounded-lg divide-y divide-[#e8e8ed]" }
const _hoisted_9 = { class: "flex items-center justify-between px-4 py-2.5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f7f8e]" }, "Unidade", -1)
const _hoisted_11 = { class: "text-sm font-semibold text-[#16161d]" }
const _hoisted_12 = { class: "flex items-center justify-between px-4 py-2.5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f7f8e]" }, "Escala", -1)
const _hoisted_14 = { class: "text-sm font-semibold text-[#16161d]" }
const _hoisted_15 = { class: "flex items-center justify-between px-4 py-2.5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f7f8e]" }, "Data de criação", -1)
const _hoisted_17 = { class: "text-sm font-semibold text-[#16161d]" }
const _hoisted_18 = { class: "flex items-center justify-between px-4 py-2.5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f7f8e]" }, "Aprovado por", -1)
const _hoisted_20 = { class: "text-sm font-semibold text-[#16161d]" }
const _hoisted_21 = { class: "flex items-center justify-between px-4 py-2.5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-[#7f7f8e]" }, "Valor estimado total", -1)
const _hoisted_23 = { class: "text-sm font-semibold text-[#16161d]" }
const _hoisted_24 = { class: "flex flex-col gap-3 mt-5" }
const _hoisted_25 = { class: "flex items-center justify-between" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold text-[#16161d]" }, "Plantões inclusos", -1)
const _hoisted_27 = { class: "text-xs font-semibold text-primary30 bg-white border border-primary30 rounded px-2 py-1" }
const _hoisted_28 = { class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg" }
const _hoisted_29 = { class: "w-full border-collapse" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-[#f0f0f4]" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-xs font-bold text-[#272735] text-center" }, "Data"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-xs font-bold text-[#272735] text-center" }, "Posição"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-xs font-bold text-[#272735] text-center" }, "Turno"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-xs font-bold text-[#272735] text-center" }, "Valor")
  ])
], -1)
const _hoisted_31 = { class: "px-4 py-2.5 text-[13px] text-[#16161d] text-center" }
const _hoisted_32 = { class: "px-4 py-2.5 text-[13px] text-[#16161d] text-center" }
const _hoisted_33 = { class: "px-4 py-2.5 text-[13px] text-[#16161d] text-center" }
const _hoisted_34 = { class: "px-4 py-2.5 text-[13px] text-[#16161d] text-center" }
const _hoisted_35 = { class: "flex justify-center" }

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import type { AdminQueueResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import { formatCurrency } from '@/utils/formatters'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import HandoverStatusBadge from './HandoverStatusBadge.vue'
import DoctorInfo from '@/components/DoctorInfo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverHistoryDetailModal',
  props: {
    modelValue: { type: Boolean },
    item: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;





const formatDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

const formatDateTime = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), "dd/MM/yyyy 'às' HH:mm")
  } catch {
    return dateStr
  }
}

const destinyDoctor = computed(() => {
  const invite = props.item?.currentCandidate ?? props.item?.package.invites[0]
  return invite?.doctor ?? null
})
const destinyName = computed(() => destinyDoctor.value?.name ?? '-')
const destinyCrm = computed(() => {
  const crm = destinyDoctor.value?.crm
  return crm ? `CRM ${crm}` : ''
})

const healthUnitName = computed(() => props.item?.package.stations[0]?.healthUnit.name ?? '-')
const scheduleName = computed(() => props.item?.package.schedule.name ?? '-')
const formattedCreatedAt = computed(() =>
  props.item ? formatDateTime(props.item.package.createdAt) : '-'
)
const formattedValue = computed(() => {
  const total = (props.item?.package.stations ?? []).reduce((sum, s) => sum + (s.value ?? 0), 0)
  return formatCurrency(total)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-[700px]",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.item)
          ? (_openBlock(), _createBlock(HandoverStatusBadge, {
              key: 0,
              status: _ctx.item.package.status
            }, null, 8, ["status"]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_35, [
        _createVNode(FilledButton, {
          text: "Voltar para o histórico de aprovação de trocas",
          width: "100%",
          height: "44px",
          class: "bg-primary30",
          "data-testid": "detail-back-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        })
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.item)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(DoctorInfo, {
                  name: _ctx.item.package.requester.name,
                  subtitle: `CRM ${_ctx.item.package.requester.crm}`,
                  "avatar-url": _ctx.item.package.requester.avatarUrl,
                  "nps-score": _ctx.item.package.requester.npsScore,
                  size: "xl"
                }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(DoctorInfo, {
                  name: destinyName.value,
                  subtitle: destinyCrm.value,
                  "avatar-url": destinyDoctor.value?.avatarUrl,
                  "nps-score": destinyDoctor.value?.npsScore,
                  size: "xl"
                }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(healthUnitName.value), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(scheduleName.value), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(formattedCreatedAt.value), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.item.reviewerName ? _unref(getFirstAndSecondName)(_ctx.item.reviewerName) : '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(formattedValue.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.item.package.stations.length) + " Plantões na troca ", 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("table", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.package.stations, (station) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: station.id,
                        class: "border-t border-[#e8e8ed]"
                      }, [
                        _createElementVNode("td", _hoisted_31, _toDisplayString(formatDate(station.date)), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(station.position ?? '-'), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(station.type ?? '-'), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatCurrency)(station.value ?? 0)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})